// extracted by mini-css-extract-plugin
export default {"link":"root_navbar-button-module__link___QjEGQ","icon":"root_navbar-button-module__icon___Ub0M8"};